(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pivot-banner-with-carousel"] && !Shopify.designMode) return;
  try {
    
  class PivotCarruBanner extends HTMLElement {
    constructor() {
      super()
      this.slider = this.querySelector('pivot-carousel')
      if(this.slider.inited) this.init()
      else this.slider.addEventListener('init', () => this.init())
    }
    init() {
      console.log('Haciendo el init')
      const splide = this.slider.splide
      const max = Math.ceil(splide.Components.Elements.slides.length / this.slider.desktopColumns)
      const $range = this.querySelector('.pivot-carrubanner-progress')
      $range.type = 'range'
      $range.min = 0
      $range.value = 0
      $range.step = 0.1
      this.appendChild($range)
      $range.addEventListener('input', e => {
        const index = Math.round(Number(e.target.value))
        console.log(index)
        splide.Components.Controller.go(index)
      })
      splide.on('mounted resize', () => {
        const totalSlides = splide.Components.Elements.slides.length
        const perPage = innerWidth > 750 ? this.slider.desktopColumns : this.slider.mobileColumns
        const totalScrollWidth = perPage * 100 / totalSlides
        $range.max = splide.Components.Controller.getEnd()
        if(totalScrollWidth >= 100) $range.style.setProperty('visibility','hidden')
        else $range.style.setProperty('visibility','visible')
        $range.style.setProperty('--scroll-width', `${totalScrollWidth}%`)
      })
      splide.on( 'mounted move dragging scroll', () => {
        $range.value = splide.Components.Controller.getIndex()
      });
    }
  }
  if(!customElements.get('pivot-carrubanner')) {
    customElements.define('pivot-carrubanner', PivotCarruBanner)
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pivot-collection-tabs"] && !Shopify.designMode) return;
  try {
    
class PivotCollectionTabs extends HTMLElement {
  constructor() {
    super()
    this.ACTIVE_CLASS = 'pivot-collection-tabs__active'
    this.ACTIVE_TAB_CLASS = 'pivot-collection-tabs__tab--active'
    this.tabs = [...this.querySelectorAll('.pivot-collection-tabs__tab')]
    this.isButtonsStyle = this.classList.contains('pivot-menu-buttons')
  }
  connectedCallback() {
    if(!this.isConnected) return
    this.tabs.forEach(btn => btn.addEventListener('click', e => {
      const currentTab = this.querySelector(`.pivot-collection-tabs__tab.${this.ACTIVE_TAB_CLASS}`)
      const newTab = e.target.closest('button')
      const currentSection = this.querySelector(`.pivot-collection-tabs__collection-carousel.${this.ACTIVE_CLASS}`)
      const newActiveSection = this.querySelector(`.pivot-collection-tabs__collection-carousel#${newTab.dataset.tab}`)
      if(currentSection) currentSection.classList.remove(this.ACTIVE_CLASS)
      if(currentTab) {
        currentTab.classList.remove(this.ACTIVE_TAB_CLASS)
        if(this.isButtonsStyle) currentTab.classList.add('button--secondary')
      }
      if(newActiveSection) newActiveSection.classList.add(this.ACTIVE_CLASS)
      if(newTab) {
        newTab.classList.add(this.ACTIVE_TAB_CLASS)
        if(this.isButtonsStyle) newTab.classList.remove('button--secondary')
      }
    }))
  }
}
if(!customElements.get('pivot-collection-tabs')) {
  customElements.define('pivot-collection-tabs', PivotCollectionTabs)
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pivot-product-details"] && !Shopify.designMode) return;
  try {
    
  class PivotProductDescription extends HTMLElement {
    constructor() {
      super();
      this.$triggersWrapper = this.querySelector('.pivot-product-description__tabs');
      this.$$triggers = this.$triggersWrapper.querySelectorAll('button');
      this.$contentsWrapper = this.querySelector('.pivot-product-description__contents');

      this.$$triggers.forEach((button) => {
        button.addEventListener('click', (e) => {
          const currentActive = this.$triggersWrapper.querySelector('button.active');
          if (currentActive) currentActive.classList.remove('active');
          button.classList.add('active');

          const currentSectionActive = this.$contentsWrapper.querySelector('details[open]');
          if (currentSectionActive) currentSectionActive.open = false;

          const selector = `details[data-link="${button.dataset.link}"]`;
          const newSectionActive = this.$contentsWrapper.querySelector(selector);
          if (newSectionActive) newSectionActive.open = true;
        });
      });
    }
  }
  if (!customElements.get('pivot-product-description')) {
    customElements.define('pivot-product-description', PivotProductDescription);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pivot-shop-the-look"] && !Shopify.designMode) return;
  try {
    
  class PivotShopTheLook extends HTMLElement {
    constructor() {
      super();
      this.slides = [...this.querySelectorAll('.pivot-shop-the-look__content .splide__slide')];
      this.indicators = [...this.querySelectorAll('.pivot-stl-indicator')];
      this.carousel = this.querySelector('pivot-carousel, pivot-vertical-slider');
      this.image = this.querySelector('.pivot-shop-the-look__image-wrapper img');

      const unselect = () => {
        this.slides.forEach((slide, slIndex) => {
          slide.classList.toggle('pivot-active', true);
          this.indicators[slIndex].querySelector('details').open = false;
        });
      };

      this.indicators.forEach((el, index) => {
        const details = el.querySelector('details > :not(summary)');
        el.addEventListener('mouseover', (e) => {
          this.carousel.splide?.go(index);
          this.slides.forEach((slide, slIndex) => {
            slide.classList.toggle('pivot-active', slIndex === index);
            if (el.offsetLeft < 110) details.classList.add('position-left');
            if (el.parentElement.offsetWidth - el.offsetLeft < 110) details.classList.add('position-right');
            if (el.parentElement.offsetHeight - el.offsetTop < details.offsetHeight - 10)
              details.classList.add('position-top');
            this.indicators[slIndex].querySelector('details').open = slIndex === index;
          });
        });
        details.addEventListener('mouseout', unselect, true);
      });

      this.image?.addEventListener('click', unselect);
      this.image?.addEventListener('mouseout', unselect);
    }
  }
  if (!customElements.get('pivot-shop-the-look')) {
    customElements.define('pivot-shop-the-look', PivotShopTheLook);
  }

  class PivotVerticalSlider extends HTMLElement {
    async connectedCallback() {
      if (!this.isConnected) return;
      await import('https://cdn.jsdelivr.net/npm/@splidejs/splide@4.1.4/dist/js/splide.min.js');
      this.$slider = this.querySelector('.splide');
      const resize = () => {
        this.height = (innerWidth > 750 ? this.closest('.pivot-shop-the-look__wrapper') : this.closest('.pivot-shop-the-look__content')).offsetHeight;
        this.size = Math.floor((this.height - 100) / 200);
        this.$images = this.querySelectorAll('.pivot-shop-the-look .card__inner');
        this.$slider.style.height = `${this.height}px`;
  
        this.$images.forEach((item) => (item.style.width = innerWidth > 750 ? `${this.height / this.size}px`: '50%'));
      }
      resize()
      addEventListener('resize', () => resize())

      this.splide = new Splide(this.$slider, {
        direction: 'ttb',
        perPage: this.size,
        gap: 'var(--grid-desktop-vertical-spacing)',
        height: this.height - 100,
        autoHeight: true,
        arrows: this.getAttribute('arrows') === 'true',
        pagination: this.getAttribute('pagination') === 'true',
        breakpoints: {
          750: {
            gap: 'var(--grid-mobile-vertical-spacing)',
            arrows: this.getAttribute('mobile-arrows') === 'true',
            pagination: this.getAttribute('mobile-pagination') === 'true',
          }
        }
      });
      this.splide.mount();
    }
  }
  if (!customElements.get('pivot-vertical-slider')) {
    customElements.define('pivot-vertical-slider', PivotVerticalSlider);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pivot-store-attributes"] && !Shopify.designMode) return;
  try {
    
class PivotStoreAttributes extends HTMLElement {
  async connectedCallback() {
    if(!this.isConnected) return 
    await import('https://cdn.jsdelivr.net/npm/@splidejs/splide@4.1.4/dist/js/splide.min.js');
    this.splide = new Splide(this,{
      autoWidth: true,
      arrows: false,
      pagination: false,
    })
    this.splide.mount()
  }
}
if(!customElements.get("pivot-store-attributes")) {
  customElements.define("pivot-store-attributes", PivotStoreAttributes)
}

  } catch(e) { console.error(e); }
})();
})();
